export const experienceData = [
    {
    id: 1,
    company: 'Exploring 3D scene reconstruction and generative world model approaches to simulate LiDAR perception for railway autonomous systems.',
    jobtitle: 'Master Thesis - SNCF (Paris): Leveraging Generative World Models for Autonomous Railway Simulation',
    startYear: 'Feb. 2026',
    endYear: 'Sept. 2026'
},
    {
        id: 2,
        company: 'Analyzed the carbon footprint of IT systems and cloud infrastructure. Conducted an experimental study on the energy impact of LLMs, evaluating batching strategies and prompt engineering to define optimization strategies.',
        jobtitle: 'Data Sciences Internship - Roche (Madrid)',
        startYear: 'Juil. 2025',
        endYear: 'Jan. 2026'
    },
    {
        id: 3,
        company: 'Tutored high school and post-maturity students',
        jobtitle: 'Private Tutor – Math, Physics & Chemistry',
        startYear: '2020',
        endYear: '2025'
    },
    
    {
        id: 4,
        company: 'Led the mentoring program for first-year students. Coordinated and motivated a team of mentors, organized support activities, and developed strong leadership skills.',
        jobtitle: 'Mentor & Program Coordinator – EPFL Mentoring Program',
        startYear: 'Jul 2024',
        endYear: 'Feb 2025'
    },

    {
        id: 5,
        company: 'Gained hands-on experience in machining processes, including CNC programming and operation, while contributing to various projects at the Technical School.',
        jobtitle: 'Machining Internship – Technical School, École des Métiers de Lausanne (ETML)',
        startYear: 'Jul 2024',
        endYear: 'Feb 2025'
    }
]
